export const currentEventUrl = 'https://www.youtube.com/watch?v=7kxjy7IerqY';
